'use strict';

function datesMonth(reportService, I18N) {
  return {
    restrict: 'E',
    require: 'ngModel',
    replace: true,
    template: `<div class="row">
      <div class="large-6 columns">
        <select ng-model="period" ng-options="idx as month for (idx, month) in months track by idx"></select>
      </div>
      <div class="large-6 columns">
        <select ng-options="year for year in years" ng-model="year"></select>
      </div>
    </div>`,
    link: (scope, el, attr, ctrl) => {
      scope.years = reportService.years();
      scope.period = moment().month();
      scope.year = moment().year();
      scope.months = I18N.datepicker.months;

      ctrl.$setViewValue({
        from: moment().year(scope.year).month(scope.period).startOf('month').format('YYYY-MM-DD'),
        to: moment().year(scope.year).month(scope.period).endOf('month').format('YYYY-MM-DD')
      });

      function update() {
        let params = angular.extend(ctrl.$viewValue, {
          from: moment().year(scope.year).month(scope.period).startOf('month').format('YYYY-MM-DD'),
          to: moment().year(scope.year).month(scope.period).endOf('month').format('YYYY-MM-DD')
        });

        ctrl.$setViewValue(params);
      }

      scope.$watchGroup(['period', 'year'], function (val, old) {
        if (val !== old) {
          update();
        }
      });
    }
  };
}

function datesMvaPeriod(reportService) {
  return {
    restrict: 'E',
    require: 'ngModel',
    replace: true,
    template: `<div class="row">
      <div class="large-6 columns">
        <select ng-model="period">
          <option value="0">jan-feb</option>
          <option value="2">mar-apr</option>
          <option value="4">mai-jun</option>
          <option value="6">jul-aug</option>
          <option value="8">sep-okt</option>
          <option value="10">nov-des</option>
        </select>
      </div>
      <div class="large-6 columns">
        <select ng-options="year for year in years" ng-model="year"></select>
      </div>
    </div>`,
    link: (scope, el, attr, ctrl) => {
      scope.years = reportService.years();
      scope.period = (moment().month() + 1) % 2 ? moment().month() : moment().month() - 1;
      scope.year = moment().year();

      ctrl.$setViewValue({
        from: moment().year(scope.year).month(scope.period).startOf('month').format('YYYY-MM-DD'),
        to: moment().year(scope.year).month(scope.period).add(1, 'months').endOf('month').format('YYYY-MM-DD')
      });

      function update() {
        let params = angular.extend(ctrl.$viewValue, {
          from: moment().year(scope.year).month(scope.period).startOf('month').format('YYYY-MM-DD'),
          to: moment().year(scope.year).month(scope.period).add(1, 'months').endOf('month').format('YYYY-MM-DD')
        });

        ctrl.$setViewValue(params);
      }

      scope.$watchGroup(['period', 'year'], function (val, old) {
        if (val !== old) {
          update();
        }
      });
    }
  };
}

function datesQuarter(reportService) {
  return {
    restrict: 'E',
    require: 'ngModel',
    replace: true,
    template: `<div class="row">
      <div class="large-6 columns">
        <select ng-model="period">
          <option value="1">1. kvartal - jan-mars</option>
          <option value="2">2. kvartal - apr-jun</option>
          <option value="3">3. kvartal - jul-sep</option>
          <option value="4">4. kvartal - okt-des</option>
        </select>
      </div>
      <div class="large-6 columns">
        <select ng-options="year for year in years" ng-model="year"></select>
      </div>
    </div>`,
    link: (scope, el, attr, ctrl) => {
      scope.years = reportService.years();
      scope.period = moment().quarter();
      scope.year = moment().year();

      ctrl.$setViewValue({
        from: moment().year(scope.year).quarter(scope.period).startOf('quarter').format('YYYY-MM-DD'),
        to: moment().year(scope.year).quarter(scope.period).endOf('quarter').format('YYYY-MM-DD')
      });

      function update() {
        let params = angular.extend(ctrl.$viewValue, {
          from: moment().year(scope.year).quarter(scope.period).startOf('quarter').format('YYYY-MM-DD'),
          to: moment().year(scope.year).quarter(scope.period).endOf('quarter').format('YYYY-MM-DD')
        });

        ctrl.$setViewValue(params);
      }

      scope.$watchGroup(['period', 'year'], function (val, old) {
        if (val !== old) {
          update();
        }
      });
    }
  };
}

function datesHalfYear(reportService) {
  return {
    restrict: 'E',
    require: 'ngModel',
    replace: true,
    template: `<div class="row">
      <div class="large-6 columns">
        <select ng-model="period">
          <option value="0">jan-jun</option>
          <option value="1">jul-des</option>
        </select>
      </div>
      <div class="large-6 columns">
        <select ng-options="year for year in years" ng-model="year"></select>
      </div>
    </div>`,
    link: (scope, el, attr, ctrl) => {
      scope.years = reportService.years();
      scope.period = moment().month() < 5 ? 0 : 1;
      scope.year = moment().year();

      if (scope.period <= 0) {
        // first half
        ctrl.$setViewValue({
          from: moment().year(scope.year).month(0).startOf('month').format('YYYY-MM-DD'),
          to: moment().year(scope.year).month(5).endOf('month').format('YYYY-MM-DD')
        });
      } else {
        // second half
        ctrl.$setViewValue({
          from: moment().year(scope.year).month(6).startOf('month').format('YYYY-MM-DD'),
          to: moment().year(scope.year).month(11).endOf('month').format('YYYY-MM-DD')
        });
      }

      function update() {
        let dates;

        if (scope.period <= 0) {
          // first half
          dates = {
            from: moment().year(scope.year).month(0).startOf('month').format('YYYY-MM-DD'),
            to: moment().year(scope.year).month(5).endOf('month').format('YYYY-MM-DD')
          };
        } else {
          // second half
          dates = {
            from: moment().year(scope.year).month(6).startOf('month').format('YYYY-MM-DD'),
            to: moment().year(scope.year).month(11).endOf('month').format('YYYY-MM-DD')
          };
        }

        ctrl.$setViewValue(angular.extend(ctrl.$viewValue, dates));
      }

      scope.$watchGroup(['period', 'year'], function (val, old) {
        if (val !== old) {
          update();
        }
      });
    }
  };
}

function datesYear(reportService) {
  return {
    restrict: 'E',
    require: 'ngModel',
    replace: true,
    template: '<div><select ng-options="year for year in years" ng-model="year"></select></div>',
    link: (scope, el, attr, ctrl) => {
      scope.years = reportService.years();
      scope.year = moment().year();

      ctrl.$setViewValue({
        from: moment().year(scope.year).month(0).startOf('month').format('YYYY-MM-DD'),
        to: moment().year(scope.year).month(11).endOf('month').format('YYYY-MM-DD')
      });

      scope.$watch('year', function () {
        let params = {
          from: moment().year(scope.year).month(0).startOf('month').format('YYYY-MM-DD'),
          to: moment().year(scope.year).month(11).endOf('month').format('YYYY-MM-DD')
        };

        ctrl.$setViewValue(params);
      });
    }
  };
}

function datesCustom(commonService) {
  return {
    restrict: 'E',
    require: 'ngModel',
    replace: true,
    template: `<div class="row">
      <div class="large-6 columns">
        <input type="text" id="from" ng-model="dates.from" placeholder="dd.mm.åå">
      </div>
      <div class="large-6 columns">
        <input type="text" id="to" ng-model="dates.to" placeholder="dd.mm.åå">
      </div>
    </div>`,
    link: (scope, el, attr, ctrl) => {
      commonService.datePicker({
        format: 'YYYY-MM-DD',
        field: el.find('#from')[0],
        onSelect: function () {
          let dates = angular.extend(ctrl.$viewValue, {
            from: el.find('#from').val()
          });

          ctrl.$setViewValue(dates);
        }
      });

      commonService.datePicker({
        format: 'YYYY-MM-DD',
        field: el.find('#to')[0],
        onSelect: function () {
          let dates = angular.extend(ctrl.$viewValue, {
            to: el.find('#to').val()
          });

          ctrl.$setViewValue(dates);
        }
      });

      scope.$watch('dates', function (val) {
        ctrl.$setViewValue(val);
        angular.extend(ctrl.$viewValue, val);
      });
    }
  };
}

function reportDates($compile, $timeout) {
  return {
    restrict: 'AE',
    require: 'ngModel',
    replace: true,
    template: `<fieldset>
      <h3 class="subheader">Velg tidsperiode</h3>
      <select name="range" id="range" ng-model="range">
        <option value="month">En måned</option>
        <option value="mvaPeriod">MVA-periode</option>
        <option value="quarter">Kvartal</option>
        <option value="halfYear">Halvår</option>
        <option value="year">År</option>
        <option value="custom">Egendefinert tidsperiode</option>
      </select>
      <div id="options"></div>
    </fieldset>`,
    link: (scope, el, attr, ctrl) => {
      $timeout(function () {
        if (ctrl) {
          scope.dates = ctrl.$viewValue;
        } else {
          scope.dates = {
            from: moment().startOf('month').format('YYYY-MM-DD'),
            to: moment().endOf('month').format('YYYY-MM-DD')
          };
        }

        if (!attr.default) {
          scope.range = 'month';
        } else {
          scope.range = attr.default;
        }

        const ranges = {
          month: '<dates-select-month ng-model="dates"/>',
          mvaPeriod: '<dates-select-mvaperiod ng-model="dates"/>',
          quarter: '<dates-select-quarter ng-model="dates"/>',
          halfYear: '<dates-select-halfyear ng-model="dates"/>',
          year: '<dates-select-year ng-model="dates"/>',
          custom: '<dates-custom ng-model="dates"/>'
        };

        scope.$watch('range', function (val) {
          if (val in ranges) {
            el.find('#options').html(ranges[val]);
            $compile(el.contents())(scope);
          }
        });

        scope.$watchCollection('dates', function (val) {
          let params = angular.extend(ctrl.$viewValue, val);
          ctrl.$setViewValue(params);
        });
      }, 300);
    }
  };
}

datesMonth.$inject = ['reportService', 'I18N'];
datesMvaPeriod.$inject = ['reportService'];
datesQuarter.$inject = ['reportService'];
datesHalfYear.$inject = ['reportService'];
datesYear.$inject = ['reportService'];
datesCustom.$inject = ['commonService'];
reportDates.$inject = ['$compile', '$timeout'];

angular
  .module('SendRegning')
  .directive('datesSelectMonth', datesMonth)
  .directive('datesSelectMvaperiod', datesMvaPeriod)
  .directive('datesSelectQuarter', datesQuarter)
  .directive('datesSelectHalfyear', datesHalfYear)
  .directive('datesSelectYear', datesYear)
  .directive('datesCustom', datesCustom)
  .directive('reportDates', reportDates);
